export default "__VITE_ASSET__DiSl4six__"